// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let PropertyShowingsList = require("../../common/Components/PropertyShowingsList.bs.js");
let Property__Components = require("../../../reason/clients/components/Property/Property__Components.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let PropertyWizardFormRelay__Validators__Showings = require("./PropertyWizardFormRelay__Validators__Showings.bs.js");
let PropertyWizardRelayPreviewShowingsList_draft_graphql = require("../../../__generated__/PropertyWizardRelayPreviewShowingsList_draft_graphql.bs.js");
let PropertyWizardRelayPreviewShowingsList_displayHelpers_graphql = require("../../../__generated__/PropertyWizardRelayPreviewShowingsList_displayHelpers_graphql.bs.js");

let convertFragment = PropertyWizardRelayPreviewShowingsList_displayHelpers_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayPreviewShowingsList_displayHelpers_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreviewShowingsList_displayHelpers_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardRelayPreviewShowingsList_displayHelpers_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayPreviewShowingsList_displayHelpers_graphql.node, convertFragment, fRef);
}

let DisplayHelpersFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

let convertFragment$1 = PropertyWizardRelayPreviewShowingsList_draft_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayPreviewShowingsList_draft_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreviewShowingsList_draft_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardRelayPreviewShowingsList_draft_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayPreviewShowingsList_draft_graphql.node, convertFragment$1, fRef);
}

let DraftFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function PropertyWizardRelay__Preview__ShowingsList$Display(props) {
  let displayHelpers = RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreviewShowingsList_displayHelpers_graphql.node, convertFragment, props.displayHelpers);
  let showings = Stdlib_Option.getOr(displayHelpers.showings, []).map(s => s.fragmentRefs);
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx(PropertyShowingsList.make, {
        showings: showings,
        shouldShowPropertyDetails: true
      }),
      Stdlib_Option.getOr(props.error, null)
    ],
    className: "border-1 border-gray-800 rounded-md"
  });
}

let Display = {
  make: PropertyWizardRelay__Preview__ShowingsList$Display
};

function PropertyWizardRelay__Preview__ShowingsList(props) {
  let onEditForm = props.onEditForm;
  let draft = RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreviewShowingsList_draft_graphql.node, convertFragment$1, props.draft);
  let showingsValid = PropertyWizardFormRelay__Validators__Showings.use(draft.fragmentRefs);
  let error = showingsValid === "Invalid" ? JsxRuntime.jsx(Property__Components.MissingFieldMarker.make, {
      text: "One or more entered showings has errors.",
      onClick: _event => onEditForm("showings")
    }) : undefined;
  return JsxRuntime.jsx(PropertyWizardRelay__Preview__ShowingsList$Display, {
    displayHelpers: props.displayHelpers,
    error: error
  });
}

let MissingFieldMarker;

let Validators;

let make = PropertyWizardRelay__Preview__ShowingsList;

exports.MissingFieldMarker = MissingFieldMarker;
exports.Validators = Validators;
exports.DisplayHelpersFragment = DisplayHelpersFragment;
exports.DraftFragment = DraftFragment;
exports.Display = Display;
exports.make = make;
/* react/jsx-runtime Not a pure module */
